import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {noop} from 'lodash';

import Button from '/component/base/Button';
import BasePopover from '/component/base/Popover';
import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './DeleteProfilePopover.style';
interface DeleteProfilePopoverProps {
  tt: (key: string, defaultValue?: string) => string;
  onSubmit: () => void;
  onCancel: () => void;
  popoverClose: () => void;
  currentScreen: string;
  destinationURL: string;
}

export const DeleteProfilePopover = ({
  tt = withTranslation.ttDefaultProp,
  onSubmit = noop,
  popoverClose = noop,
}: DeleteProfilePopoverProps) => {
  return (
    <BasePopover style={styles.modalView} padded>
      <TouchableOpacity
        {...testProperties(DownlineProfile.candidateDeleteModal, true)}>
        <View style={styles.modalBody}>
          <Text
            variant="heading"
            style={styles.headerText}
            {...testProperties(DownlineProfile.candidateDeleteModalHeader)}>
            {tt(
              'confirmation',
              'Are you sure you want to remove this profile?',
            )}
          </Text>
          <Text
            variant="body"
            style={styles.bodyText}
            {...testProperties(DownlineProfile.candidateDeleteModalBody)}>
            {tt('sure', 'All related information will be lost.')}
          </Text>
        </View>
        <View style={styles.modalFooter}>
          <Button
            onPress={onSubmit()}
            style={{
              base: styles.buttonBox,
            }}
            testId={DownlineProfile.candidateDeleteModalDeleteButton}>
            Delete Profile
          </Button>
          <Button
            type="textLink"
            onPress={popoverClose}
            style={{
              base: styles.buttonBox,
              // @ts-expect-error TS(2339): Property 'textStyle' does not exist on type '{ bas... Remove this comment to see the full error message
              text: styles.textStyle,
            }}
            testId={DownlineProfile.candidateDeleteModalCancelButton}>
            Cancel
          </Button>
        </View>
      </TouchableOpacity>
    </BasePopover>
  );
};

export default withTranslation('DeleteProfilePopoverModal')(
  DeleteProfilePopover,
);
